import { Modal, ModalContent } from '@restworld/ui-ds-base';

export interface ModalWrapperProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  showBackButton?: boolean;
  onBack?: () => void;
}

export const ModalWrapper = ({ open, onClose, children, showBackButton, onBack }: ModalWrapperProps) => {
  return (
    <Modal open={open} onOpenChange={(v) => !v && onClose()}>
      <ModalContent className="lg:min-w-[31.75rem] lg:max-w-[31.75rem]" showBackButton={showBackButton} onBack={onBack}>
        {children}
      </ModalContent>
    </Modal>
  );
};
